const casNumberPattern = /[1-9]{1}[0-9]{1,6}-\d{2}-\d\b/gm

// returns true if input string is a valid CAS Number query
const isCASNumberQuery = (term: string): boolean => {
  if (!casNumberPattern.test(term)) return false

  const validPrefixes = ['cas ', 'cas no ', 'cas number ']
  const validSuffixes = [' cas', ' cas number']
  const termSansCas = term.trim().replace(casNumberPattern, '')
  return (
    termSansCas === '' ||
    validPrefixes.includes(termSansCas) ||
    validSuffixes.includes(termSansCas)
  )
}

export default isCASNumberQuery
